import React, { useState, useEffect } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Grid,
    CircularProgress,
    Snackbar,
    Alert,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    Paper,
    Table,
    TableBody,
    Chip,
    LinearProgress,
    Pagination, FormControl, InputLabel, MenuItem, Select,
    Modal,
} from '@mui/material';
import {
    Work,
    HourglassTop,
    CheckCircle,
    Assignment,
    Category,
    CalendarToday,
    Event,
    Timeline,
    LibraryAdd
} from '@mui/icons-material';
import axios from 'axios';
import { axiosInstance, localAxiosGet } from '../../../Axios/axios';
import ProjectDetails from './ProjectDetails';
import TokenExpirePopup from '../../../components/TokenExpirePopup';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../../components/loade';
const statusColorMap = {
    'Total': { muiColor: 'default', color: '#1a237e' },
    'In Progress': { muiColor: 'warning', color: '#e65100' },
    'Todo': { muiColor: 'info', color: '#006064' },
    'Completed': { muiColor: 'success', color: '#1b5e20' },
    'Overdue': { muiColor: 'error', color: '#8B0000' },
};


const EmployeeProjects = () => {
    const [projectsData, setProjectsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const userId = localStorage.getItem('userId');
    const [error, setError] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('error');
    const [selectedStatus, setSelectedStatus] = useState('Total'); 

    
    const [projectCounts, setProjectCounts] = useState({
        total: 0,
        ongoing: 0, 
        upcoming: 0, 
        completed: 0,
        overdue: 0,
    });

   
    const [pagination, setPagination] = useState({
        page: 1, 
       
        totalPages: 1,
    });

    const [isProjectDetailsDialogOpen, setIsProjectDetailsDialogOpen] = useState(false);
    const [selectedProjectId, setSelectedProjectId] = useState('');
    const [sortOption, setSortOption] = useState('newest');
    const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
    const navigate = useNavigate();
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
    };

    const sortProjectsByDate = (projects) => {
        return [...projects].sort((a, b) => {
            const dateA = a.created_at ? new Date(a.created_at) : new Date(a.start_date);
            const dateB = b.created_at ? new Date(b.created_at) : new Date(b.start_date);
            return dateB - dateA;
        });
    };
    const accessToken = localStorage.getItem('accessToken');

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                setIsLoading(true);
                const statusQuery = selectedStatus === 'Total' ? '' : `&status=${selectedStatus}`;
               
                const response = await axiosInstance(localAxiosGet(`/project/getProjectsByEmployeeId/${userId}?page=${pagination.page}&limit=${rowsPerPage}${statusQuery}`, accessToken));

                if (response.data.status === 'SUCCESS') {
                    const projectData = response.data.message.data.map(project => ({
                        id: project.id,
                        name: project.project_title,
                        status: project.status,
                        category: project.status,
                        startdate: formatDate(project.start_date),
                        deadline: formatDate(project.end_date),
                        progress: project.progress,
                        priority: project.priority,
                        description: project.description,
                        created_at: project.createdAt || project.start_date,
                        start_date: project.start_date
                    }));

                    setProjectsData(sortProjectsByDate(projectData));

                    // Update projectCounts state
                    setProjectCounts({
                        total: response.data.message.total_project_count || 0,
                        ongoing: response.data.message.inprogress_count || 0,
                        upcoming: response.data.message.todo_project_count || 0,
                        completed: response.data.message.completed_project_count || 0, 
                        overdue: response.data.message.overdue_count || 0,
                    });

                    // Update pagination state
                    setPagination(prev => ({
                        ...prev,
                        totalPages: response.data.message.totalPages || 1,
                        
                    }));

                } else {
                    setError("Failed to fetch projects");
                    setSnackbarMessage(response.data.message.message || "Failed to fetch projects");
                    setSnackbarOpen(true);
                    setSnackbarSeverity('error');
                    setProjectsData([]);
                    setProjectCounts({ total: 0, ongoing: 0, upcoming: 0, completed: 0, overdue: 0 });
                    setPagination({ page: 1, limit: rowsPerPage, totalPages: 1 });
                }
            } catch (err) {
                // if (err.response && err.response.status === 403) {
                //     setOpenTokenExpirePopup(true);
                // } else
                    
                    if (err.response && err.response.status === 404) {
                    setProjectsData([]);
                    setError(null);
                    setProjectCounts({ total: 0, ongoing: 0, upcoming: 0, completed: 0, overdue: 0 });
                    setPagination({ page: 1, limit: rowsPerPage, totalPages: 1 });
                } else {
                    setError("Error fetching projects: " + err.message);
                    setSnackbarMessage("Error fetching projects: " + err.message);
                    setSnackbarSeverity('error');
                    console.error("Error fetching projects:", err);
                    setProjectsData([]);
                    setProjectCounts({ total: 0, ongoing: 0, upcoming: 0, completed: 0, overdue: 0 });
                    setPagination({ page: 1, limit: rowsPerPage, totalPages: 1 });
                }
            } finally {
                setTimeout(() => {
                    setIsLoading(false);
                }, 1000);
            }
        };

        fetchProjects();


    }, [userId, pagination.page,rowsPerPage, selectedStatus, accessToken]);


    // Update the project status cards with the new API counts
    const projectsStatus = [
        { label: "Total", count: projectCounts.total, icon: <Work />, color: "#2196F3", statusFilter: 'Total', labelColor: '#1a237e', countColor: '#1a237e' },
        { label: "Ongoing", count: projectCounts.ongoing, icon: <HourglassTop />, color: "#FF9800", statusFilter: 'In Progress', labelColor: '#e65100', countColor: '#e65100' },
        { label: "Upcoming", count: projectCounts.upcoming, icon: <LibraryAdd />, color: "#00f1f5", statusFilter: 'Todo', labelColor: '#006064', countColor: '#006064' },
        { label: "Completed", count: projectCounts.completed, icon: <CheckCircle />, color: "#35f921", statusFilter: 'Completed', labelColor: '#1b5e20', countColor: '#1b5e20' },
        { label: "Overdue", count: projectCounts.overdue, icon: <Event />, color: "#FF0000", statusFilter: 'Overdue', labelColor: '#8B0000', countColor: '#8B0000' }, // Added Overdue
    ];

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    
    const displayProjects = projectsData;

    const handleCardClick = (status) => {
        setSelectedStatus(status);
        setPagination(prev => ({ ...prev, page: 1 })); 
        setRowsPerPage('5')
    };

    
    const handlePageChange = (event, newPage) => {
        setPagination(prev => ({ ...prev, page: newPage }));
    };

    const handleProjectDetails = (id) => {
        setSelectedProjectId(id);
        setIsProjectDetailsDialogOpen(true);
    };

    const handleProjectDetailsClose = () => {
        setIsProjectDetailsDialogOpen(false);
       
        setPagination(prev => ({ ...prev, page: prev.page }));
    };

    const handleProjectUpdated = (updatedProject) => {
        setProjectsData(prevProjects => {
            const formattedUpdatedProject = {
                id: updatedProject.id,
                name: updatedProject.project_title,
                status: updatedProject.status,
                category: updatedProject.status,
                startdate: formatDate(updatedProject.start_date),
                deadline: formatDate(updatedProject.end_date),
                progress: updatedProject.progress || 0,
                priority: updatedProject.priority,
                description: updatedProject.description,
                created_at: updatedProject.created_at || updatedProject.start_date,
                start_date: updatedProject.start_date
            };
            const updatedProjects = prevProjects.map(project =>
                project.id === updatedProject.id ? formattedUpdatedProject : project
            );
            return sortProjectsByDate(updatedProjects);
        });
    };

    // const handleCloseTokenExpirePopup = () => {
    //     setOpenTokenExpirePopup(false);
    //     navigate('/');
    // };
    

    return (
        <>
        {isLoading && <Loader />}
        <Box sx={{ paddingRight: 3, minHeight: '75vh' }}>
            <Typography variant="h4" fontWeight="bold" marginBottom={2} marginTop={3}>
               My Projects
            </Typography>
            <Grid container spacing={3}>
                {projectsStatus.map((item, index) => (
                    <Grid item xs={6} md={4} lg={3} key={index} mt={2}>
                        <Card
                            onClick={() => handleCardClick(item.statusFilter)}
                            sx={{
                                background: `linear-gradient(to right, ${item.color}33, ${item.color}11)`,
                                boxShadow: 3,
                                padding: 2,
                                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                                cursor: 'pointer',
                                '&:hover': {
                                    transform: 'scale(1.1)',
                                    boxShadow: '0px 0px 20px rgba(0,0,0,0.3)',
                                    zIndex: 1,
                                    border: `1px solid ${item.color}`,
                                    '& svg': {
                                        transform: 'rotate(10deg)',
                                        transition: 'transform 0.3s ease-in-out',
                                    },
                                },
                                '& svg': {
                                    transition: 'transform 0.3s ease-in-out',
                                },
                            }}
                        >
                            <CardContent sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: 2,
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}>
                                <Box>
                                    <Typography variant="h6" sx={{ color: item.labelColor }}>{item.label}</Typography>
                                    <Typography variant="h4" fontWeight="bold" sx={{ fontSize: '2.5rem', color: item.countColor }}>
                                        {item.count}
                                    </Typography>
                                </Box>
                                <Box sx={{ '& .MuiSvgIcon-root': { fontSize: 50, color: item.color } }}>
                                    {item.icon}
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <TableContainer component={Paper} sx={{ mt: 3 }}>
                <Table>
                    <TableHead sx={{ backgroundColor: '#a8fdf5' }}>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Assignment />
                                    Project Name
                                </Box>
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Category />
                                    Status
                                </Box>
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <CalendarToday />
                                    Start Date
                                </Box>
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Event />
                                    Deadline
                                </Box>
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Timeline />
                                    Progress
                                </Box>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { displayProjects.length > 0 ? (
                            displayProjects.map((project) => (
                                <TableRow
                                    key={project.id}
                                    onClick={() => handleProjectDetails(project.id)}
                                    sx={{
                                        cursor: 'pointer',
                                        '&:hover': {
                                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                        }
                                    }}
                                >
                                    <TableCell sx={{ fontWeight: '600', fontSize: '14px', wordWrap: 'break-word' }}>
                                        {project.name}
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={project.status}
                                            color={statusColorMap[project.status]?.muiColor || 'default'}
                                        />

                                    </TableCell>
                                    <TableCell>{project.startdate}</TableCell>
                                    <TableCell>{project.deadline}</TableCell>
                                    <TableCell>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <LinearProgress
                                                variant="determinate"
                                                value={project.progress}
                                                sx={{ width: '100%', height: 10, borderRadius: 5 }}
                                            />
                                            <Typography variant="body2">{project.progress}%</Typography>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={5} align="center">
                                    No projects found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                {/* MUI Pagination component */}

            </TableContainer>
            <Box sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                backgroundColor: '#f8fafc',
                borderTop: '1px solid #e2e8f0',
                p: 2
            }}>
                <FormControl size="small" sx={{ minWidth: 120 }}>
                            <InputLabel>Rows per page</InputLabel>
                            <Select
                                value={rowsPerPage}
                                onChange={(e) => setRowsPerPage(e.target.value)}
                                label="Rows per page"
                            >
                                <MenuItem value={5}>5</MenuItem>
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={25}>25</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                            </Select>
                        </FormControl>

                {pagination.totalPages >= 1 && ( 
                    <Pagination
                        count={pagination.totalPages}
                        page={pagination.page}
                        onChange={handlePageChange}
                        color="primary"

                        sx={{
                            '& .MuiPaginationItem-root': {
                                borderRadius: '8px',
                                '&.Mui-selected': {
                                    background: 'linear-gradient(135deg, #6366F1 0%, #A855F7 100%)',
                                    color: 'white',
                                    '&:hover': {
                                        background: 'linear-gradient(135deg, #5B5BD6 0%, #9333EA 100%)',
                                    }
                                },
                                '&:not(.Mui-selected):hover': {
                                    backgroundColor: 'rgba(99, 102, 241, 0.1)',
                                }
                            }
                        }}
                    // showFirstButton
                    // showLastButton
                    />
                )}
            </Box>

           
                <ProjectDetails
                 open={isProjectDetailsDialogOpen}
                    selectedProjectId={selectedProjectId}
                    onClose={handleProjectDetailsClose}
                    onProjectUpdated={handleProjectUpdated}
                />
           

            {/* <Modal
                open={openTokenExpirePopup}
                onClose={handleCloseTokenExpirePopup}
                aria-labelledby="token-expire-modal-title"
                aria-describedby="token-expire-modal-description"
            >
                <TokenExpirePopup onClose={handleCloseTokenExpirePopup} />
            </Modal> */}

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Box>
        </>
    );
};

export default EmployeeProjects;   